import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const pageBackground = "#F4F5F8";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    backgroundColor: pageBackground,
    borderRadius: "6px",
    border: `1px solid ${theme.palette.divider}`,
    "& > .MuiPaper-root": {
      width: "100%",
      backgroundColor: "transparent",
    },
    "& .MuiTableContainer-root": {
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto !important",
      overflowY: "hidden",
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.divider} transparent`,
      "&::-webkit-scrollbar": {
        height: "8px",
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: "4px",
      },
    },
    "& .MuiTable-root": {
      width: "max-content",
      minWidth: "100%",
      borderCollapse: "collapse",
      background: `${pageBackground} !important`,
      backgroundColor: `${pageBackground} !important`,
    },
    "& .MuiTableCell-root": {
      padding: "8px 4px",
      fontSize: "13px",
      textAlign: "center",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.palette.text.primary,
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiTableCell-head, & .MuiTableBody-root .MuiTableCell-root": {
      height: "52px !important",
      padding: "0 4px !important",
      boxSizing: "border-box",
      border: "none !important",
      borderBottom: `1px solid ${theme.palette.divider} !important`,
    },
    "& .MuiTableCell-head, & [class*='cellHead']": {
      fontSize: "14px",
      fontWeight: 500,
      fontStyle: "normal",
      lineHeight: "21px",
      letterSpacing: 0,
      textAlign: "right !important" as "right",
      whiteSpace: "normal",
      wordBreak: "break-word",
      background: `${pageBackground} !important`,
      backgroundColor: `${pageBackground} !important`,
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
  },
}));
